module.exports = __webpack_public_path__ + "img/biaoqing.ba1b9f57.png";